export default __webpack_public_path__ + "static/media/POSTER 4.22578cbc.JPG";